import { appLanguages, languages as allLang } from '../../../shared/utils/lists';

const getAvailableLanguageFromNavigator = () => {
  let lang = 'en';
  const availableLanguages = appLanguages.map((language) => language.code);

  if (window.navigator) {
    let languages = [window.navigator.language.slice(0, 2)];
    if (window.navigator.languages && window.navigator.languages.length > 0) {
      languages = window.navigator.languages.map((lang) => lang.slice(0, 2));
    }
    lang = languages.find((language) => availableLanguages.includes(language)) || lang;
  }
  return lang;
};

const getLanguageFromNavigator = () => {
  let lang = 'en';
  const availableLanguages = allLang.list.map((language) => language[1]);

  if (window.navigator) {
    let navigatorLanguages = [window.navigator.language.slice(0, 2)];
    if (window.navigator.languages && window.navigator.languages.length > 0) {
      navigatorLanguages = window.navigator.languages.map((lang) => lang.slice(0, 2));
    }
    lang = navigatorLanguages.find((language) => availableLanguages.includes(language)) || lang;
  }
  return lang;
};

export { getAvailableLanguageFromNavigator, getLanguageFromNavigator };
